import { render, staticRenderFns } from "./ShopInfo.vue?vue&type=template&id=2dac9d0a&lang=pug&"
import script from "./ShopInfo.vue?vue&type=script&lang=ts&"
export * from "./ShopInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports